import React from 'react';
import Icon from './Icon';
import { journey } from '../data';

export default function Journey() {
  return (
    <section className="section" id="journey">
      <div className="container">
        <header className="section__head">
          <h2 className="section__title">The Journey So Far</h2>
        </header>

        <div className="timeline">
          <div className="timeline__track">
            {journey.map((j) => (
              <div className="milestone" key={j.title}>
                <span className="milestone__dot">
                  <Icon name={j.icon} size={22} />
                </span>
                {j.year && <span className="milestone__year">{j.year}</span>}
                <h3 className="milestone__title">{j.title}</h3>
                <p className="milestone__desc">{j.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
